export const isMobileSelector = (state) => Boolean(state.deviceType.isMobile);
export const isTabletSelector = (state) => Boolean(state.deviceType.isTablet);
export const isDesktopSelector = (state) => Boolean(state.deviceType.isDesktop);
// export const isIpadOsSelector = (state) => Boolean(state.deviceType.isIpadOs);
